/**
 * Masque partiellement un numéro VIN pour des raisons de sécurité
 * Affiche les 11 premiers caractères et masque les 6 derniers
 * @param {string} vin - Le numéro VIN complet (17 caractères)
 * @returns {string} Le VIN partiellement masqué
 */
export const formatVin = (vin) => {
  if (!vin || vin.length !== 17) return vin || 'N/C';
  const visiblePart = vin.substring(0, 11);
  const hiddenPart = '•'.repeat(6); // Utilisation de • pour masquer les caractères
  return `${visiblePart}${hiddenPart}`;
};

/**
 * Formate un prix en Francs CFA (FCFA)
 * @param {number} price - Le prix à formater
 * @returns {string} Le prix formaté avec le symbole FCFA
 */
export const formatPrice = (price) => {
  if (price === null || price === undefined) return 'N/A';
  return new Intl.NumberFormat('fr-FR', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(price) + ' FCFA';
};
